import React, { Component } from "react";
import PeppOperationSelector from "../../crdm/PeppOperationSelector";
import { Container, FormCheck } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { closeModal } from "../../../store/actions/ModalActions";
import moment from "moment";
import { DatePicker } from "@material-ui/pickers";

const currentDate = new Date(new Date().setDate(new Date().getDate() - 1));

class DailyReportsViewFilter extends Component {
  state = {
    isOverall: true,
    isGenerating: false,
    isDateFilterOpen: false,
    covered_date: currentDate,
    isDateFilterFromOpen: false,
    dateFrom: currentDate,
    isDateFilterToOpen: false,
    dateTo: currentDate,
    openBy: "Overall",
    clusterId: null,
    areas: null,
    branches: [],
    isClusterMultiSelect: false,
    isAreaMultiSelect: false,
    isDateFilterInDateRange: false,
  };

  onSelectedBranchChanged = (data) => {
    this.setState({ branches: data });
  };

  onAreaChanged = (data) => {
    this.setState({ areas: data });
  };

  onClusterChanged = (data) => {
    this.setState({ clusterId: data });
  };
  onSelectedByChanged = (openBy) => {
    this.setState({ openBy: openBy });
  };

  render() {
    return (
      <Container>
        <Row>
          <Col>
            <Form className="mt-2">
              <Form.Group className="d-flex justify-content-end">
                <Form.Check
                  id="dateFilterInDateRange"
                  checked={this.state.isDateFilterInDateRange}
                  onChange={(e) => {
                    this.setState({
                      isDateFilterInDateRange: e.target.checked,
                    });
                  }}
                  type="switch"
                  label="Specific Period"
                />
              </Form.Group>
              {this.state.isDateFilterInDateRange ? (
                <Form.Group className="d-flex">
                  <Form.Group className="flex-grow-1 mr-2">
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      className="strong"
                      onClick={() => {
                        this.setState({
                          isDateFilterFromOpen: true,
                        });
                      }}
                      readOnly={true}
                      value={moment(
                        this.state.dateFrom !== null
                          ? this.state.dateFrom
                          : new Date()
                      ).format("MMMM DD YYYY")}
                      type="text"
                    />
                    <DatePicker
                      onClose={() => {
                        this.setState({ isDateFilterFromOpen: false });
                      }}
                      onChange={(e) => {
                        this.setState({
                          dateFrom: e,
                          isDateFilterFromOpen: false,
                        });
                      }}
                      value={this.state.dateFrom}
                      maxDate={
                        new Date(new Date().setDate(new Date().getDate() - 1))
                      }
                      maxDateMessage="Max date"
                      hidden={true}
                      openTo="year"
                      views={["month", "year", "date"]}
                      format="MMMM DD YYYY"
                      open={this.state.isDateFilterFromOpen}
                    />
                  </Form.Group>
                  <Form.Group className="flex-grow-1 ml-2">
                    <Form.Label>To</Form.Label>
                    <Form.Control
                      className="strong"
                      onClick={() => {
                        this.setState({
                          isDateFilterToOpen: true,
                        });
                      }}
                      readOnly={true}
                      value={moment(
                        this.state.dateTo !== null
                          ? this.state.dateTo
                          : new Date()
                      ).format("MMMM DD YYYY")}
                      type="text"
                    />
                    <DatePicker
                      onClose={() => {
                        this.setState({ isDateFilterToOpen: false });
                      }}
                      onChange={(e) => {
                        this.setState({
                          dateTo: e,
                          isDateFilterToOpen: false,
                        });
                      }}
                      value={this.state.dateTo}
                      minDate={this.state.dateFrom}
                      maxDate={
                        this.state.dateFrom
                          ? new Date(
                              Math.min(
                                new Date(
                                  new Date(this.state.dateFrom).setDate(
                                    new Date(this.state.dateFrom).getDate() + 31
                                  )
                                ),
                                new Date(
                                  new Date().setDate(new Date().getDate() - 1)
                                ) // Yesterday's date
                              )
                            )
                          : new Date(
                              new Date().setDate(new Date().getDate() - 1)
                            ) // Default to yesterday if no "From" date is set
                      }
                      maxDateMessage="Max date is yesterday"
                      hidden={true}
                      openTo="year"
                      views={["month", "year", "date"]}
                      format="MMMM DD YYYY"
                      open={this.state.isDateFilterToOpen}
                    />
                  </Form.Group>
                </Form.Group>
              ) : (
                <Form.Group>
                  <Form.Label>Covered Date</Form.Label>
                  <Form.Control
                    className="strong"
                    onClick={() => {
                      this.setState({
                        isDateFilterOpen: true,
                      });
                    }}
                    readOnly={true}
                    value={moment(
                      this.state.covered_date !== null
                        ? this.state.covered_date
                        : new Date()
                    ).format("MMMM DD YYYY")}
                    type="text"
                  />
                  <Form.Text className="text-muted">
                    Click to change date.
                  </Form.Text>
                  <DatePicker
                    onClose={() => {
                      this.setState({ isDateFilterOpen: false });
                    }}
                    onChange={(e) => {
                      this.setState({
                        covered_date: e,
                        isDateFilterOpen: false,
                      });
                    }}
                    value={this.state.rankingPeriod}
                    maxDate={
                      new Date(new Date().setDate(new Date().getDate() - 1))
                    }
                    maxDateMessage="Max date"
                    hidden={true}
                    openTo="year"
                    views={["month", "year", "date"]}
                    format="MMMM DD YYYY"
                    open={this.state.isDateFilterOpen}
                  />
                </Form.Group>
              )}
              <Form.Group>
                <FormCheck
                  label="Overall"
                  checked={this.state.isOverall}
                  onChange={(e) => {
                    this.setState({
                      isOverall: e.target.checked,
                      openBy: e.target.checked ? "Overall" : "Cluster",
                    });
                  }}
                />
              </Form.Group>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <div hidden={this.state.isOverall}>
              <PeppOperationSelector
                onSelectedBranchChanged={this.onSelectedBranchChanged}
                onSelectedByChanged={this.onSelectedByChanged}
                onClusterChanged={this.onClusterChanged}
                onAreaChanged={this.onAreaChanged}
                isClusterMultiSelect={this.state.isClusterMultiSelect}
                isAreaMultiSelect={this.state.isAreaMultiSelect}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              disabled={this.state.isGenerating}
              className="float-right mt-3"
              onClick={() => {
                if (this.state.isDateFilterInDateRange) {
                  switch (this.state.openBy) {
                    case "Overall":
                      this.setState({ isGenerating: true });
                      this.props
                        .getByOverallDateRange(
                          moment(this.state.dateFrom).format("MMMM DD YYYY"),
                          moment(this.state.dateTo).format("MMMM DD YYYY")
                        )
                        .then((r) => {
                          this.setState({ isGenerating: false });
                          closeModal();
                        });
                      break;

                    case "Cluster":
                      if (this.state.clusterId) {
                        this.setState({ isGenerating: true });
                        this.props
                          .getByClusterDateRange(
                            this.state.clusterId.map((d) => d.id),
                            moment(this.state.dateFrom).format("MMMM DD YYYY"),
                            moment(this.state.dateTo).format("MMMM DD YYYY")
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        alert("Please Select Cluster");
                      }
                      break;

                    case "Area":
                      if (this.state.areas) {
                        this.setState({ isGenerating: true });
                        this.props
                          .getByAreaDateRange(
                            this.state.areas.map((d) => d.area_code),
                            moment(this.state.dateFrom).format("MMMM DD YYYY"),
                            moment(this.state.dateTo).format("MMMM DD YYYY")
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        alert("Please Select Area");
                      }
                      break;

                    case "Branch":
                      if (
                        this.state.branches &&
                        this.state.branches.length > 0
                      ) {
                        this.setState({ isGenerating: true });
                        this.props
                          .getByBranchDateRange(
                            this.state.branches.map((item) => item.value),
                            moment(this.state.dateFrom).format("MMMM DD YYYY"),
                            moment(this.state.dateTo).format("MMMM DD YYYY")
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        alert("Please Select Branch");
                      }
                      return;

                    default:
                      break;
                  }
                } else {
                  switch (this.state.openBy) {
                    case "Overall":
                      this.setState({ isGenerating: true });
                      this.props
                        .getByOverall(
                          moment(this.state.covered_date).format("MMMM DD YYYY")
                        )
                        .then((r) => {
                          this.setState({ isGenerating: false });
                          closeModal();
                        });
                      break;

                    case "Cluster":
                      if (this.state.clusterId) {
                        this.setState({ isGenerating: true });
                        this.props
                          .getByCluster(
                            this.state.clusterId.map((d) => d.id),
                            moment(this.state.covered_date).format(
                              "MMMM DD YYYY"
                            )
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        alert("Please Select Cluster");
                      }
                      break;

                    case "Area":
                      if (this.state.areas) {
                        this.setState({ isGenerating: true });
                        if (
                          process.env.REACT_APP_USE_CONCURRENT_REQUEST ===
                          "true"
                        ) {
                          this.props
                            .getByAreaOptimized(
                              this.state.areas,
                              moment(this.state.covered_date).format(
                                "MMMM DD YYYY"
                              )
                            )
                            .then((r) => {
                              this.setState({ isGenerating: false });
                              closeModal();
                            });
                        } else {
                          this.props
                            .getByArea(
                              this.state.areas.map((d) => d.area_code),
                              moment(this.state.covered_date).format(
                                "MMMM DD YYYY"
                              )
                            )
                            .then((r) => {
                              this.setState({ isGenerating: false });
                              closeModal();
                            });
                        }
                      } else {
                        alert("Please Select Area");
                      }
                      break;

                    case "Branch":
                      if (
                        this.state.branches &&
                        this.state.branches.length > 0
                      ) {
                        this.setState({ isGenerating: true });
                        this.props
                          .getByBranch(
                            this.state.branches.map((item) => item.value),
                            this.state.covered_date
                          )
                          .then((r) => {
                            this.setState({ isGenerating: false });
                            closeModal();
                          });
                      } else {
                        alert("Please Select Branch");
                      }
                      return;

                    default:
                      break;
                  }
                }
              }}
            >
              {this.state.isGenerating ? "Generating..." : "Generate Report"}
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DailyReportsViewFilter;
